import { useEffect, useState } from 'react';
import { getReevaluateOptIn, ReevaluateOptIn, saveReevaluateOptIn } from '../../api/reevaluation';
import { describeError } from '../../api/requeue';
import { useAxiosSwagger } from '../../hooks/useAxiosSwagger';
import { moment } from './issueFormat';
import { latestOf } from './reevaluateOptInModel';

export interface IReevaluateOptInToggleProps {
    customer: string;
    environment: string;
}

/**
 * Whether the rollout watch of this environment starts a dry run of the backlog an hour after a
 * deploy. Without a choice of its own the app setting Rollout:Reevaluate decides. Admin only, like
 * the endpoint behind it.
 */
export const ReevaluateOptInToggle = ({ customer, environment }: IReevaluateOptInToggleProps) => {
    const axios = useAxiosSwagger();
    const [optIn, setOptIn] = useState<ReevaluateOptIn | null>(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!axios) {
            return;
        }

        let current = true;

        setOptIn(null);
        getReevaluateOptIn(axios, customer, environment)
            .then((read) => current && setOptIn((shown) => latestOf(shown, read)))
            .catch((ex) => current && setError(describeError(ex)));

        return () => {
            current = false;
        };
    }, [axios, customer, environment]);

    const change = (enabled: boolean) => {
        if (!axios) {
            return;
        }

        setBusy(true);
        setError(null);

        saveReevaluateOptIn(axios, customer, environment, enabled)
            .then(setOptIn)
            .catch((ex) => setError(describeError(ex)))
            .finally(() => setBusy(false));
    };

    const title = error
        ? error
        : optIn?.changedBy
        ? `${optIn.enabled ? 'Aangezet' : 'Uitgezet'} door ${optIn.changedBy} op ${moment(optIn.changedAt)}`
        : optIn
        ? `Standaard ${optIn.effective ? 'aan' : 'uit'}`
        : undefined;

    return (
        <label className="env-card__opt-in form-check" title={title}>
            <input
                type="checkbox"
                className="form-check-input"
                checked={optIn?.effective === true}
                disabled={busy || !optIn}
                onChange={(event) => change(event.target.checked)}
            />
            <span className="form-check-label">Herbeoordelen</span>
            {error && <span className="text-danger"> (mislukt)</span>}
        </label>
    );
};
